export { default as ExamThemeTitle } from './ExamThemeTitle'
export { default as Timer } from './Timer'
export { default as TimerChapter } from './TimerChapter'
export { default as ExamQuesList } from './ExamQuesList'
export { default as submitAlert } from './submitAlert'
export { default as leaveScreen } from './leaveScreen'
//小题类型
export { default as ExamMultipleChoice } from './ExamMultipleChoice'
export { default as ExamSingleChoice } from './ExamSingleChoice'
export { default as ExamMultipleChoiceSimple } from './ExamMultipleChoiceSimple'
export { default as ExamSingleChoiceSimple } from './ExamSingleChoiceSimple'
export {default as hasChildQuestion} from './ExamShortAnswer/hasChildQuestion'
export {default as withoutChildQuestion} from './ExamShortAnswer/withoutChildQuestion'

export { default as formula } from './formula'
export { default as matrix } from './matrix'
export { default as examEnd } from './examEnd'
export { default as subjectiveMark } from './subjectiveMark'
export { default as DialogMatrix } from './DialogMatrix'



